module.exports = __webpack_public_path__ + "img/jichuang1.8380965f.jpg";